import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField as MuiTextField } from '@mui/material';

const TextField = ({
	control,
	name,
	placeholder = '',
	type = 'text',
	error,
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => (
				<MuiTextField
					{...field}
					type={type}
					placeholder={placeholder}
					fullWidth
					variant="outlined"
					error={!!error}
					helperText={error?.message}
					sx={{
						'& .MuiOutlinedInput-root': {
							height: '48px',
							backgroundColor: '#ffffff',
							'& fieldset': {
								borderColor: '#e2e8f0',
							},
							'&:hover fieldset': {
								borderColor: '#cbd5e1',
							},
							'&.Mui-focused fieldset': {
								borderColor: '#0064b1',
							},
						},
						'& .MuiInputBase-input': {
							fontSize: '0.875rem',
							'&::placeholder': {
								color: '#94a3b8',
								opacity: 1,
							},
						},
					}}
				/>
			)}
		/>
	);
};

export default TextField;
